import { render, staticRenderFns } from "./MaidClaimUpdateStatus.vue?vue&type=template&id=df344ac2&"
import script from "./MaidClaimUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./MaidClaimUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./MaidClaimUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidClaimUpdateStatus.vue"
export default component.exports